/* =====================================================================
   LYP custom sections — shared JS
   Loaded by each lyp-* section that needs it. Safe to include multiple
   times; initialisers are idempotent and guard against missing nodes.
   ===================================================================== */

(function () {
  'use strict';

  function initStickySubnav() {
    var nav = document.querySelector('.lyp-subnav');
    if (!nav || nav.dataset.lypSubnavReady === 'true') return;
    nav.dataset.lypSubnavReady = 'true';

    var links = Array.prototype.slice.call(
      nav.querySelectorAll('a[data-lyp-subnav-target]')
    );
    if (links.length === 0) return;

    var pairs = links
      .map(function (link) {
        var target = document.getElementById(link.dataset.lypSubnavTarget);
        return target ? { link: link, target: target } : null;
      })
      .filter(Boolean);

    // Smooth scroll with offset for the sticky bar (and any sticky header).
    function offset() {
      var headerOffset = 0;
      var stickyHeader = document.querySelector('sticky-header, .header-wrapper--sticky');
      if (stickyHeader) headerOffset = stickyHeader.getBoundingClientRect().height;
      return nav.getBoundingClientRect().height + headerOffset + 8;
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.dataset.lypSubnavTarget;
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset();
        window.scrollTo({ top: top, behavior: 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    // Scroll-spy: highlight the link whose section is currently in view.
    if (pairs.length === 0 || typeof IntersectionObserver === 'undefined') return;

    var setActive = function (link) {
      links.forEach(function (l) { l.classList.remove('lyp-subnav__link--active'); });
      if (link) link.classList.add('lyp-subnav__link--active');
    };

    var observer = new IntersectionObserver(
      function (entries) {
        // Sort by document position; pick the topmost intersecting one.
        var visible = entries
          .filter(function (e) { return e.isIntersecting; })
          .map(function (e) {
            var pair = pairs.find(function (p) { return p.target === e.target; });
            return pair ? { pair: pair, top: e.boundingClientRect.top } : null;
          })
          .filter(Boolean)
          .sort(function (a, b) { return a.top - b.top; });

        if (visible.length > 0) setActive(visible[0].pair.link);
      },
      {
        // Activate a section when its top crosses just under the sticky bar.
        rootMargin: '-' + (nav.offsetHeight + 1) + 'px 0px -55% 0px',
        threshold: 0
      }
    );

    pairs.forEach(function (p) { observer.observe(p.target); });
  }

  /* --- Reviews carousel ----------------------------------------- */

  function initReviewsCarousel(root) {
    if (root.dataset.lypReviewsReady === 'true') return;
    root.dataset.lypReviewsReady = 'true';

    var track    = root.querySelector('[data-lyp-reviews-track]');
    var prevBtn  = root.querySelector('[data-lyp-reviews-action="prev"]');
    var nextBtn  = root.querySelector('[data-lyp-reviews-action="next"]');
    var dotsWrap = root.querySelector('[data-lyp-reviews-dots]');
    if (!track || !dotsWrap) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.lyp-reviews__card'));
    var total = cards.length;
    if (total === 0) return;
    var current = 0;

    function isMobile() { return window.innerWidth <= 767; }
    function gapPx()    { return isMobile() ? 14 : 20; }
    function cardW()    { return cards[0].offsetWidth + gapPx(); }

    function addSpacers() {
      var w = cards[0].offsetWidth;
      ['lyp-reviews__spacer--pre', 'lyp-reviews__spacer--post'].forEach(function (cls, i) {
        var sp = document.createElement('div');
        sp.className = 'lyp-reviews__spacer ' + cls;
        sp.style.cssText = 'flex: 0 0 ' + w + 'px; pointer-events: none;';
        if (i === 0) track.insertBefore(sp, track.firstChild);
        else track.appendChild(sp);
      });
    }

    function removeSpacers() {
      Array.prototype.forEach.call(
        track.querySelectorAll('.lyp-reviews__spacer'),
        function (s) { s.remove(); }
      );
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lyp-reviews__dot';
        dot.setAttribute('aria-label', (i + 1) + '番目');
        (function (idx) {
          dot.addEventListener('click', function () { goTo(idx); });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    function updateActive() {
      cards.forEach(function (c, i) {
        c.classList.toggle('lyp-reviews__card--active', i === current);
      });
    }

    function updateDots() {
      Array.prototype.forEach.call(
        dotsWrap.querySelectorAll('.lyp-reviews__dot'),
        function (d, i) {
          d.classList.toggle('lyp-reviews__dot--active', i === current);
        }
      );
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, total - 1));
      track.style.transform = 'translateX(-' + (current * cardW()) + 'px)';
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= total - 1;
      updateActive();
      updateDots();
    }

    function reset() {
      removeSpacers();
      if (!isMobile()) addSpacers();
      buildDots();
      goTo(total > 1 ? 1 : 0);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(reset, 120);
    });

    reset();
  }

  function initAllReviewsCarousels() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-lyp-reviews]'),
      initReviewsCarousel
    );
  }

  /* --- FAQ accordion ------------------------------------------- */

  function initFaq(root) {
    if (root.dataset.lypFaqReady === 'true') return;
    root.dataset.lypFaqReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lyp-faq-item]'));
    if (items.length === 0) return;

    function closeAll() {
      items.forEach(function (item) {
        item.classList.remove('is-open');
        var b = item.querySelector('[data-lyp-faq-question]');
        var a = item.querySelector('[data-lyp-faq-answer]');
        if (b) b.setAttribute('aria-expanded', 'false');
        if (a) a.setAttribute('aria-hidden', 'true');
      });
    }

    items.forEach(function (item) {
      var button = item.querySelector('[data-lyp-faq-question]');
      if (!button) return;
      button.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        closeAll();
        if (!wasOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          var answer = item.querySelector('[data-lyp-faq-answer]');
          if (answer) answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  function initAllFaqs() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-lyp-faq]'),
      initFaq
    );
  }

  function init() {
    initStickySubnav();
    initAllReviewsCarousels();
    initAllFaqs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme-editor section events so the editor preview
  // picks up newly added blocks/sections without a full reload.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})(); 